import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulatePricingTableStock = ({ commit, dispatch, state, rootState }, payload) => {
    var objAuth = JSON.parse(rootState.objAuthorize);
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
      .then(response => {
        return response.json();
      }, error => {
        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
        commit('setSnack', snackDetails);
        console.log(error);
      }).then(data => {
      var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, 'is_library_pricelist': 1 };
      Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
        .then(response => {
          return response.json();
        }, error => {
          var snackDetails = { color: 'error', message: 'An error has occured', display: true };
          commit('setSnack', snackDetails);
          console.log(error);
        }).then(dt => {
        var priceList = dt[0];
        var listDetails = { token: data.token, list_id: priceList.pl_id };

        Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', { params: listDetails }, rootState.headerDetails)
          .then(response => {
            return response.json();
          }, error => {
            var snackDetails = { color: 'error', message: 'An error has occured', display: true };
            commit('setSnack', snackDetails);
          }).then(d => {
            var codes = [];
            var pricing_tables = [];
            for( var x in d ) {
              var uom = 'each';
              if( d[x].pli_uom != '' ) {
                uom = d[x].pli_uom;
              }
              codes.push({ uom: uom, name: d[x].pli_description, code: d[x].pli_code, pricing_table: d[x].pli_pricing_table, quantity: 0, new_quantity: 0 });
              pricing_tables.push({ pricing_table: d[x].pli_pricing_table });
            }
            commit('fncSetStockData', codes);
            commit('fncSetPricingTables', pricing_tables);
            commit( 'fncSetStockLoaded', true );
        });
      });
    });
}

export const fncPopulateSavedStock = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=getStockLevels', { manufacturer: objAuth.manufacturer }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {

      commit( 'fncSetSavedStock', data );

  });
}

export const fncUpdateStock = ({ commit, dispatch, state, rootState }, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=updateStockLevels', { manufacturer: objAuth.manufacturer, stock: payload }, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error has occured', display: true };
      commit('setSnack', snackDetails);
      console.log(error);
    }).then(data => {

      if( data == true ) {
        var snackDetails = { color: 'success', message: 'Stock levels have been updated successfully', display: true };
        commit('setSnack', snackDetails);
      } else {
        var snackDetails = { color: 'error', message: 'Stock level update has failed', display: true };
        commit('setSnack', snackDetails);
      }

      setTimeout(function(){
        location.reload();
      }, 1500)

  });
}

export const fncDownloadStockCsv = ({ commit, dispatch, state, rootState }, payload) => {

  var importResult = 'Product Code,Product Name, Stock Level' + "\n";
  for( var p in payload ) {
    importResult += payload[p].code + ',' + payload[p].name  + ',' + payload[p].stock + "\n";
  }

  var resultDownload = document.createElement('a');
  resultDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(importResult));
  resultDownload.setAttribute('download', 'stock_levels.csv');
  resultDownload.click();

}
